// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-tag[data-v-18426a32]{vertical-align:top}.el-tag+.el-tag[data-v-18426a32],.input-new-tag[data-v-18426a32]{margin-left:5px}.input-new-tag[data-v-18426a32]{width:90px;vertical-align:bottom}.color-picker[data-v-18426a32]{left:10px;vertical-align:top}", ""]);
// Exports
module.exports = exports;
